import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAxiosInstance } from "../../../services/Interceptor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { getCoaches } from "../../../store/CoachActions";

function SearchCoaches({
  onSearchChange = () => {},
  searchQuery,
  loadOnMount = true,
}) {
  const apiInstance = useAxiosInstance();
  const dispatch = useDispatch();
  const [localSearchQuery, setLocalSearchQuery] = useState("");
  const isControlled = searchQuery !== undefined;

  useEffect(() => {
    if (isControlled) {
      setLocalSearchQuery(searchQuery);
    }
  }, [isControlled, searchQuery]);

  useEffect(() => {
    if (!loadOnMount) {
      return;
    }

    dispatch(getCoaches(apiInstance, ""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, loadOnMount]);

  return (
    <div className="mb-0">
      <form
        className="mb-4 flex items-center w-full border border-gray-300 rounded-md overflow-hidden"
        onSubmit={(event) => event.preventDefault()}
      >
        <input
          type="text"
          placeholder="Search Coaches ..."
          value={isControlled ? searchQuery : localSearchQuery}
          onChange={(event) => {
            const nextSearchQuery = event.target.value;
            if (!isControlled) {
              setLocalSearchQuery(nextSearchQuery);
            }
            onSearchChange(nextSearchQuery);
          }}
          className="px-4 py-2 basis-11/12 focus:outline-none"
        />
        <button
          type="button"
          tabIndex={-1}
          aria-hidden="true"
          className="mr-2 basis-1/12 bg-white text-slate-500 flex items-center justify-center rounded-lg "
        >
          <FontAwesomeIcon icon={faSearch} size="lg" />
        </button>
      </form>
    </div>
  );
}

export default SearchCoaches;
